exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "@media screen and (min-width:768px){.recover-form-wrapper{max-width:600px;margin:auto}}.form__input-field{margin-bottom:16.666666666666668px}.form__input-field label{font-size:20px;font-weight:300;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;cursor:pointer}.form__input-field input:not([type=checkbox]){width:100%;padding:0 10px;background-color:#f5f5f5;border:none;border-radius:2px;box-shadow:none;color:#173031;font-size:18px;font-weight:400;line-height:40px;outline:none}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./~/stylus-loader!./src/routes/Recover.styl
// module id = 488
// module chunks = 0